export const bluetoothConstants={
    UPDATE_BLUETOOTH_STATUS: "UPDATE_BLUETOOTH_STATUS",

    BLUETOOTH_CONNECTION: "CONNECTED_BLUETOOTH_DEVICE"
}